import { Component, Vue, Watch } from 'vue-property-decorator';

import ApiService from '@/services/api.service';
import { Errors } from '@/definitions';

import template from './create-company.vue';
import apiService from '@/services/api.service';
import { Action } from '@/store';
import CreateCompanyInfo from '@/components/create-company-info';
import CreateCompanySubscription from '@/components/create-company-subscription';

@Component({
  mixins: [template],
  components: { CreateCompanyInfo, CreateCompanySubscription }
})
export default class CreateCompany extends Vue {
  currentPage: number = 1;
  title: string = this.$package.title;
  emailError: boolean = false;
  emailExistsError: boolean = false;
  createError: boolean = false;

  company = {
    companyName: '',
    user: {
      email: '',
      firstName: '',
      lastName: '',
      marketingOptIn: false
    }
  };
  subscription: { type: number } = { type: 1 };

  created() {
    if (this.$route.query.companyName) {
      this.company.companyName = this.$route.query.companyName as string;
    }
    if (this.$route.query.email) {
      this.company.user.email = this.$route.query.email as string;
    }
    if (this.$route.query.firstName) {
      this.company.user.firstName = this.$route.query.firstName as string;
    }
    if (this.$route.query.lastName) {
      this.company.user.lastName = this.$route.query.lastName as string;
    }
    if (this.$route.query.stage && this.$route.query.stage === '3') {
      this.currentPage = 3;
    }
  }

  async sendForm() {
    try {
      const result = await apiService.createCompany(this.company, this.subscription.type);
      window.location.assign(result.redirectUrl);
    } catch (e) {
      if (e.message === 'email already exists') {
        this.emailExistsError = true;
      } else {
        this.$Store.dispatch(Action.SHOW_ALERT, { text: 'alerts.company.create_error', type: 'danger' });
      }
    }
  }

  next(): void {
    this.currentPage += 1;
  }

  last(): void {
    this.currentPage -= 1;
  }
}